import { render, staticRenderFns } from "./ClasificationDetail.vue?vue&type=template&id=7602c32a&scoped=true"
import script from "./ClasificationDetail.vue?vue&type=script&lang=js"
export * from "./ClasificationDetail.vue?vue&type=script&lang=js"
import style0 from "./ClasificationDetail.vue?vue&type=style&index=0&id=7602c32a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7602c32a",
  null
  
)

export default component.exports